import {ProtocolFindBySensorDataWrapper} from '../wrappers/protocolFindBySensorDataWrapper';

export class ProtocolFindBySensorDataViewModel {
    position: number;
    serialCode: string;
    userCode: string;
    email: string;
    lastTimeUsedDate: number;
    firstTimeUsedDate: number;

    public static from(dataWrapper: ProtocolFindBySensorDataWrapper[]): ProtocolFindBySensorDataViewModel[] {
        const data = [];
        dataWrapper.forEach ((dataRow, i) => {
            const convertedData = new ProtocolFindBySensorDataViewModel();
            convertedData.position = i + 1;
            convertedData.userCode = dataRow.userCode;
            convertedData.email = dataRow.email;
            convertedData.serialCode = dataRow.serialCode;
            convertedData.lastTimeUsedDate = dataRow.lastTimeUsedDate;
            convertedData.firstTimeUsedDate = dataRow.firstTimeUsedDate;

            data.push(convertedData);
        });
        return data;
    }
}
